"use client";

import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { HomeFeaturedDevicesList } from "@/components";
import { useAtomValue } from "jotai";
import { featuredObservatoriesAtom, featuredTagAtom } from "@/store/home";
import { Button, cn } from "@oreme/ui";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { cva } from "class-variance-authority";

const sectionFeaturedDevicesVariants = cva(
  "relative flex flex-col flex-1 p-4 md:p-8 min-h-[640px] border rounded-xl bg-background",
);

function HomeFeaturedDevices(): ReactElement | null {
  const t = useTranslations("home.FeaturedDevices");
  const featuredObservatories = useAtomValue(featuredObservatoriesAtom);
  const featuredTag = useAtomValue(featuredTagAtom);

  if (!featuredObservatories || !featuredTag) return null;

  return (
    <div className={cn(sectionFeaturedDevicesVariants())}>
      <header className="text-center max-w-sm mx-auto">
        <h3 className="text-2xl font-semibold">{t("title")}</h3>
      </header>
      <div className="relative -mx-4 md:-mx-8">
        <HomeFeaturedDevicesList />
      </div>
      <footer className="text-center">
        <Button className="border-0 flex sm:inline-flex" asChild>
          <Link href={`/monitoring/?tag=${featuredTag.id}`}>
            {t("action")} <ArrowRight strokeWidth={1} />
          </Link>
        </Button>
      </footer>
    </div>
  );
}

export { HomeFeaturedDevices };
